import { ChevronRight } from "lucide-react";

export default function MenuItem({
    icon,
    title,
    onClick,
    iconBackground = "#FCECE5",
}) {
    return (
        <button className="menu-item" onClick={onClick}>
            <div
                className="menu-item__icon"
                style={{ backgroundColor: iconBackground }}
            >
                {icon}
            </div>

            <span className="menu-item__title">
                {title}
            </span>

            <ChevronRight size={22} />
        </button>
    );
}